// /home/Hakyury/sites/oauth.eight-percent.com/frontend/src/component/OAuthHeader.jsx
import React from 'react';

export default function OAuthHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-600 to-indigo-600 flex items-center justify-center border border-white/20 shadow-lg shadow-purple-500/20">
                <span className="text-white font-bold text-sm">8%</span>
              </div>
              <div className="absolute -inset-2 border border-purple-400/30 rounded-full animate-ping opacity-70"></div>
              <div className="absolute -inset-1 border border-cyan-400/20 rounded-full animate-pulse"></div>
            </div>
            <span className="text-white font-semibold bg-gradient-to-r from-purple-400 to-cyan-300 bg-clip-text text-transparent">
              OAuth
            </span>
          </div>
          
          <a 
            href="https://eight-percent.com" 
            className="group px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
          >
            <span className="text-sm text-gray-300 group-hover:text-white">
              На главный сайт →
            </span>
          </a>
        </div>
      </div>
    </header>
  );
}
